import { makeRule } from '@core/utils/rule.js'

export let searchRules = {
  name: [
    {...makeRule()},
  ],
}

export let formRules = {
  reason: [
    {...makeRule('请选择选项', 'integer')},
  ],
}



// WEBPACK FOOTER //
// ./src/views/point/point.rules.js